import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(readonly snack: MatSnackBar) { /* empty */ }

  successNotification(massage: string) {
    this.snack.open(massage, 'Close', {
      verticalPosition: 'top',
      duration: 5000,
      horizontalPosition: 'right',
      panelClass: ["custom-snackbar-success"]
    });
  }

  ErrorNotification(massage: string) {
    this.snack.open(massage, 'Close', {
      panelClass: ['custom-snackbar-error'],
      duration: 7000,
      verticalPosition: 'top',
      horizontalPosition: 'right',
    });
  }

  WarningNotification(massage: string) {
    this.snack.open(massage, 'Close', {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      panelClass: ['custom-snackbar-warning'],
    });
  }
}
